export const COLORS = "colors";
export const OFFERS = "offers";
export const PRICE_OFFERS = "priceOffers";
export const PURCHASE_MODE_OFFERS = "purchaseModeOffers";
export const BEHAVIOURS = "behaviours";
export const BEHAVIOUR_TYPES = "behaviourTypes";
export const NAVIGATIONS = "navigations";
export const OPTIONS = "options";
export const GIFTS = "gifts";
export const GIFT_CAMPAIGNS = "giftCampaigns";
export const PRODUCT_DETAIL = "productDetail";
export const MEDIA = "media";
export const INSURANCES = "insurances";
export const RELATED_OFFERS = "relatedOffers";
export const SPECS = "specs";
export const SPECS_GROUPS = "specsGroups";
